import React, { useEffect } from "react";
import "./assets/scss/themes.scss";
import Route from "./Routes";
import { ToastContainer } from "react-toastify";
import { getOrganizationId } from "./Utils/CommonUtils";
import { useSelector } from "react-redux";
import { getUserInfo, sidebarList } from "./Utils/CommonService";
import { showToast } from "./common/Toaster/Toaster";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { setAuth } from "./slices/common/reducer";
import { useDispatch } from "react-redux";

function App() {
  const selectedUser = useSelector((state) => state.header.selectedUser);

  const faviconUrl = useSelector(
    (state) =>
      state.header.selectedUser?.agsa_icon_media_url ||
      "%PUBLIC_URL%/favicon.ico"
  );

  useEffect(() => {
    const updateFavicon = (url) => {
      let link = document.querySelector("link[rel='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = url;
    };

    if (faviconUrl) {
      updateFavicon(faviconUrl);
    }
  }, [faviconUrl]);

  return (
    <React.Fragment>
      <ToastContainer limit={4} autoClose={5000} />
      <Route />
    </React.Fragment>
  );
}



export default App;
